/*
 * ctf-crest-filters.js
 * 1) Limpia emojis de menús de navegación y labels de filtros.
 * 2) Inyecta SVG crests cuando el texto matchea uno de los 9 clubes.
 * Funciona sobre el DOM actual y re-ejecuta cuando Shopify re-renderiza
 * filtros via AJAX (MutationObserver).
 */
(function () {
  'use strict';

  var CRESTS = [
    { match: ['arsenal'],                                       slug: 'arsenal' },
    { match: ['barcelona', 'barça', 'barca'],                   slug: 'barcelona' },
    { match: ['real madrid', 'madrid'],                         slug: 'real-madrid' },
    { match: ['newcastle'],                                     slug: 'newcastle' },
    { match: ['chelsea'],                                       slug: 'chelsea' },
    { match: ['manchester city', 'man city', 'mci'],            slug: 'man-city' },
    { match: ['manchester united', 'man united', 'man utd'],    slug: 'man-united' },
    { match: ['psg', 'paris saint-germain', 'paris'],           slug: 'psg' },
    { match: ['liverpool'],                                     slug: 'liverpool' }
  ];

  // Banderas SVG inyectadas para textos específicos. Solo se inyectan donde el
  // emoji nativo no renderiza bien en todos los OS (caso típico: England con
  // subdivision flag 🏴󠁧󠁢󠁥󠁮󠁧󠁿 que Windows no muestra).
  var FLAGS = [
    { match: ['england'], slug: 'england' }
  ];

  // Base URL del CDN para los SVG — la inyectamos desde theme.liquid
  var ASSET_BASE = document.currentScript && document.currentScript.dataset.base
    ? document.currentScript.dataset.base
    : '/cdn/shop/files/';

  // Lugares donde aplicar el tratamiento. injectCrest:false = solo limpia emojis.
  var TARGETS = [
    // Preferencia (Marian, 2026-05-20): NO inyectar crests, pero SÍ banderas
    // (caso England con subdivision flag que no renderiza bien).
    { sel: '.ctf-filter-check',               injectCrest: false, injectFlag: true, size: 20 },
    { sel: '.facets__label',                  injectCrest: false, injectFlag: true, size: 20 },
    { sel: '.facets__list label',             injectCrest: false, injectFlag: true, size: 20 },
    { sel: 'facet-filter-component label',    injectCrest: false, injectFlag: true, size: 20 },
    { sel: '[data-filter-block] label',       injectCrest: false, injectFlag: true, size: 20 },
    { sel: '.collection-filters label',       injectCrest: false, injectFlag: true, size: 20 },
    { sel: '.ctf-mega-col > a',               injectCrest: false, injectFlag: true, size: 18 },
    { sel: '.ctf-mobile-group-body > a',      injectCrest: false, injectFlag: true, size: 18 },
    { sel: '.ctf-mobile-link',                injectCrest: false, injectFlag: true, size: 18 }
  ];

  // Regex para emojis pictográficos + símbolos misceláneos + dingbats + selectores variación
  var EMOJI_RE = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu;

  function stripEmojis(s) {
    return (s || '').replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
  }

  function hasEmoji(s) {
    return /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u.test(s || '');
  }

  function findIn(label, dataset) {
    var c = (label || '').toLowerCase();
    if (!c) return null;
    for (var i = 0; i < dataset.length; i++) {
      var e = dataset[i];
      for (var j = 0; j < e.match.length; j++) {
        if (c.indexOf(e.match[j]) !== -1) return e.slug;
      }
    }
    return null;
  }
  function findSlug(label) { return findIn(label, CRESTS); }
  function findFlag(label) { return findIn(label, FLAGS); }

  // Tag chars (U+E0020-U+E007F) — quedan huérfanos cuando se limpia un
  // black flag emoji (U+1F3F4). Esta regex los borra para que no queden
  // caracteres invisibles raros en el texto.
  var TAG_CHARS_RE = /[\u{E0020}-\u{E007F}]/gu;

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function decorate(el, opts) {
    if (!el || el.dataset.crestDone) return;
    var raw = el.textContent;
    if (!raw) return;
    var emoji = hasEmoji(raw);
    var cleaned = stripEmojis(raw);
    if (!cleaned) return;

    var slug = opts.injectCrest ? findSlug(cleaned) : null;
    var flag = opts.injectFlag  ? findFlag(cleaned) : null;

    // Tag chars huérfanos (vienen de black-flag emoji ya removido)
    if (flag) {
      cleaned = cleaned.replace(TAG_CHARS_RE, '').replace(/\s+/g, ' ').trim();
    }

    // Nada que hacer si no hay emoji ni match
    if (!emoji && !slug && !flag) return;

    el.dataset.crestDone = '1';

    // Si hay <input> hijo (caso filtro), lo preservamos
    var existingInput = el.querySelector('input');

    var size = opts.size || 18;
    var hCrest = Math.round(size * 1.125);
    var hFlag  = Math.round(size * 0.67);

    var inner = '';
    if (slug) {
      inner += '<img class="ctf-crest" src="' + ASSET_BASE + 'crest-' + slug + '.svg" ' +
               'width="' + size + '" height="' + hCrest + '" alt="" aria-hidden="true" ' +
               'loading="lazy" decoding="async">';
    }
    if (flag) {
      // Tamaño definido por CSS para que matchee visual el emoji nativo
      inner += '<img class="ctf-flag" src="' + ASSET_BASE + 'flag-' + flag + '.svg" ' +
               'alt="" aria-hidden="true" loading="lazy" decoding="async">';
    }
    inner += '<span class="ctf-crest-label">' + escapeHtml(cleaned) + '</span>';

    var wrap = document.createElement('span');
    wrap.className = 'ctf-crest-wrap';
    wrap.innerHTML = inner;

    // Limpiamos contenido textual pero conservamos el input
    el.innerHTML = '';
    if (existingInput) el.appendChild(existingInput);
    el.appendChild(wrap);
  }

  function run(root) {
    var scope = root || document;
    for (var i = 0; i < TARGETS.length; i++) {
      var t = TARGETS[i];
      var nodes = scope.querySelectorAll(t.sel);
      for (var j = 0; j < nodes.length; j++) {
        decorate(nodes[j], t);
      }
    }
  }

  function init() {
    run(document);

    // Re-corre cuando Shopify re-renderiza filtros/menús via AJAX
    var target = document.body;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        run(document);
      });
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
